import React from "react";
export default function SVGFactory() {
  return (
    <svg viewBox="0 0 32 32">
      <g fill="#000000">
        <path
          fill="#000000"
          d="M26,14V4h-6v10h-1V4h-6v10H4v14h24V14H26z M22,6h2v8h-2V6z M15,6h2v8h-2V6z M10,26v-4h4v4H10z
    M26,26H16v-6H8v6H6V16h20V26z M18,20h2v2h-2V20z M24,22h-2v-2h2V22z"
        />
      </g>
    </svg>
  );
}
